
<template>
    <div>
        <validation-observer ref="forms" v-slot="{handleSubmit}">
            <form class="form-group" @submit.prevent="handleSubmit(submitVideo)">
                <div class="grid-1 form">

                    <validation-provider name="Título" vid="titulo" rules="required" v-slot="{errors}" tag="div" class="input-std form-text" >
                        <label>Título</label>
                        <input type="text" placeholder="Título do vídeo" v-model="form.titulo" />
                        <p class="errors">{{errors[0]}}</p>
                    </validation-provider>

                    <validation-provider name="Url" vid="url" rules="required" v-slot="{errors}" tag="div" class="input-std form-text" >
                        <label>Url do YouTube</label>
                        <input type="text" placeholder="Url do YouTube" v-model="form.url" />
                        <p class="errors">{{errors[0]}}</p>
                    </validation-provider>

                    <validation-provider name="Descrição" vid="descricao" rules="required" v-slot="{errors}" tag="div" class="input-std form-text" >
                        <label>Descrição</label>
                        <input type="text" placeholder="Descrição do Vídeo" v-model="form.descricao" />
                        <p class="errors">{{errors[0]}}</p>
                    </validation-provider>
                </div>

                <div class="flex justify-end">
                    <button class="btn btn-primary">
                        {{ (form.id === '') ? 'Salvar Vídeo' : 'Atualizar Vídeo' }}
                    </button>
                </div>
            </form>
        </validation-observer>
    </div>
</template>

<script>
    export default {
        name: 'form-video',
        data() {
            return {
                videoID: '',
                form: {
                    id: '',
                    titulo: '',
                    url: '',
                    descricao: ''
                }
            }
        },

        methods: {
            submitVideo() {
                this.axios.post('videos', this.form).then(res => {
                    if (res.status === 200) {
                        this.$swal({
                            title: 'Sucesso',
                            text: (this.form.id) ? 'O vídeo foi atualizado com sucesso' : 'O vídeo foi criado com sucesso',
                            icon: 'success',
                        })
                        this.$router.push('/sistema/videos/lista-videos')
                    }
                }).catch(error => {
                    this.$swal({
                        title: 'Ops!',
                        text: error.response.data.message,
                        icon: 'error',
                    });

                })
            },

            getVideo() {
                this.axios.get(`/videos/${this.videoID}`)
                    .then(response => {
                        const { video } = response.data;
                        this.form.titulo = video.titulo;
                        this.form.url = video.url;
                        this.form.descricao = video.descricao;
                        this.form.id = video.id;
                    })
            }
        },

        async created() {
            const { id } = this.$route.params;
            this.videoID = id;
            if (id) {
                await this.getVideo();
            }
        }
    }
</script>
<style lang="scss" scoped>
    .form {
        @media(min-width: 640px) {
            @apply grid-cols-3;
        }
    }
</style>
